import { css } from "styled-components";

export const assets_cyanish = "#31b1f9";
export const black = "#2b2b30"; // temporary change
export const bluish = "#281478";
export const bright_black = "#333333";
export const cyanish = "#e6f0ff";
export const danger_red = "#da3333";
export const dark_yellow = "#bc892e";
export const darker_blue = "#96a8ff";
export const darker_grayish = "#9f9f9f";
export const faint_grayish = "#f0f0f0";
export const faint_purplish = "#f7f6fa";
export const gray_footer_text = "#484848";
export const grayish = "#c4c4c4";
export const greenish = "#33da80";
export const light_gray = "#d9d9d9";
export const light_yellow = "#ffefbc";
export const off_black = "#2b2b30";
export const off_white = "#f5f5f5";
export const orangish = "#ffa800";
export const ppip_purple = "#f3f1ff";
export const ppip_yellow = "#e8b914";
export const purplish = "#4b32be";
export const referrer_color = "#275dc5";
export const shaded_gray = "#6a6a6a";
export const statement_green = "#4ac14a";
export const statement_red = "#c14a4a";
export const taxsam_yellow_navbar = "#fef5e0";
export const white = "#ffffff";

// Breakpoints (centralized for the rebrand + any future pages). Values chosen to
// match the existing narrowScreenMediaQuery (720px) as the mobile/tablet gate
// and 1024px as the tablet/desktop gate.
export const MOBILE_MAX_PX = 719;
export const TABLET_MAX_PX = 1023;
export const DESKTOP_MIN_PX = 1024;

export const narrowScreenMediaQuery = `screen and (max-width: ${MOBILE_MAX_PX}px)`;
export const tabletScreenMediaQuery = `screen and (min-width: ${MOBILE_MAX_PX + 1}px) and (max-width: ${TABLET_MAX_PX}px)`;
export const wideScreenMediaQuery = `screen and (min-width: ${DESKTOP_MIN_PX}px)`;

// Rebrand brand colors (per Figma 2026-04 — TLC Rebranding)
// These exact hex values come from the client's design spec; don't tweak without their sign-off.
export const brand_orange = "#EF8726";           // webinar "Daftar" button / accent orange
export const brand_orange_deep = "#D85907";       // card titles, gradient start, primary CTA
export const brand_yellow = "#F7B30C";            // gradient end (Masuk button, footer headings)
export const brand_blue = "#2A9FD6";              // webinar "Detail" button / secondary CTA
export const brand_dark = "#1F2937";
export const brand_cream = "#FEF5E0";
export const brand_success = "#16A34A";
export const brand_danger = "#DC2626";

// Primary gradient used across the rebrand (Masuk button, section dividers, accents).
export const brand_gradient = `linear-gradient(90deg, ${brand_orange_deep} 0%, ${brand_yellow} 100%)`;

// Dark mode palette. Applied via `[data-theme="dark"] &` selectors across
// styled-components. Theme is controlled by the `dark_mode_v1` FeatureToggle
// on the backend; HomesApp sets `data-theme="dark"` on the page root when the
// toggle is on. Light is the fallback when unset.
export const dark = {
  page_bg: "#0f172a",
  surface_bg: "#17171e",       // cards, header (translucent)
  surface_raised: "#1f2937",   // hovered cards
  border: "rgba(255, 255, 255, 0.08)",
  text_primary: "#f3f4f6",
  text_secondary: "#9ca3af",
  text_muted: "#6b7280",
};

export const outerContainerCss = css`
  margin-left: auto;
  margin-right: auto;
  max-width: 1240px;
  padding-left: 40px;
  padding-right: 40px;

  @media ${narrowScreenMediaQuery} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

// Shared elevation tokens for the rebrand. Use `card_shadow_sm` for the
// resting state of cards and `card_shadow_md` for hovered / promoted
// surfaces (hero banner image, prominent CTA cards).
export const card_shadow_sm =
  "0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.05)";
export const card_shadow_md = "0 6px 24px rgba(15, 23, 42, 0.08)";
